<template>
  <Layout>
    <div class="flex flex-wrap is-main-layout">
      <div class="flex-1">
        <slot />
      </div>
    </div>

    <Notifications :group="'tailwind'">
      <template #body="props">
        <Toast
          class="mt-2 mr-6"
          :isError="props.item.data.isError"
          :isWarning="props.item.data.isWarning"
          :isNotice="props.item.data.isNotice"
          :isDisabled="props.item.data.isDisabled"
          :label="props.item.text"
          :onClick="props.close"
        />
      </template>
    </Notifications>

    <!-- Loading Overlay -->
    <LoadingOverlay v-if="isShowLoading" :isFlow="true" :isPulse="false" :isCircleFade="false" />
  </Layout>
</template>

<script setup>
const isShowLoading = useIsShowLoading();
import { useNuxtApp } from '#app';

useSessionExpiry();

const { $constants } = useNuxtApp();
const layoutData = reactive({
});


</script>

<style lang="scss">
.is-main-layout {
  display: flex;
  background: linear-gradient(180deg, #FFFFFF 0%, #D1C6E6 100%);
}
</style>
